import React from 'react';

import emotionStyled from '@emotion/styled';
import Employee from 'models/employee';
// import TextParseComponent from 'components/feed/TextParseComponent';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import styled, { css } from 'styled-components';
import { StyledTypography } from 'styles/common';

import { getShortHumanReadableDate } from 'constants/helper';
import { PraiseSvgIconColored } from 'constants/icons';

import { Typography3 } from 'uiToolkit/Typography';
import { TextParseComponent } from 'uiToolkitV1/TextParseComponent';
import { TextLabel } from 'uiToolkitV1/Typography';

export default function CommentDisplay({
  fromEmployee = new Employee(),
  text,
  createdDate,
  macrosRes,
  addMention,
  displayReply,
  CommentMore,
  styleType,
  rightAlignCommentTime,
  isKudos = false,
}) {
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);
  const isLoggedInEmployeeComment = fromEmployee.id === loggedInEmployeeId;

  return (
    <Container flex={rightAlignCommentTime}>
      <TextContainer flexGrow={rightAlignCommentTime} $isKudos={isKudos}>
        {(styleType !== 'chat' || (styleType === 'chat' && !isLoggedInEmployeeComment)) && (
          <Typography3 rightGutter={0.9} display="inline">
            {fromEmployee.fullName}
          </Typography3>
        )}
        {isKudos ? (
          <>
            <PraiseSvgIconColored
              style={{ position: 'relative', bottom: '-2px' }}
              containerSize="fixed14px"
              size="fixed14px"
            />
            <VerticalDivider />
          </>
        ) : null}
        <StyledTypography display="inline" variant="body2">
          <TextParseComponent text={text} macros={macrosRes} />
        </StyledTypography>

        {isLoggedInEmployeeComment && (
          <CommentMoreContainer alignLeft={styleType === 'chat'}>{CommentMore}</CommentMoreContainer>
        )}
      </TextContainer>
      <ReplyContainer alignRight={styleType === 'chat' && isLoggedInEmployeeComment}>
        {/* {displayReply && (
          <>
            <StyledTypography
              display="inline"
              onClick={() => addMention(fromEmployee)}
              color="primary"
              variant="caption"
            >
              Reply
            </StyledTypography>
            <StyledTypography display="inline" color="textSecondary" leftGutter={0.5}>
              ·
            </StyledTypography>
          </>
        )} */}
        <TextLabel color="text.g2">{getShortHumanReadableDate(createdDate)}</TextLabel>
      </ReplyContainer>
    </Container>
  );
}

const Container = styled.div`
  display: ${(props) => (props.flex ? 'flex' : 'block')};
`;

const TextContainer = emotionStyled.div`
  background: ${(props) => props.theme.colors.neutral.F2F2F2};
  line-height: 1;
  padding: 8px 12px;
  border-radius: 4px;
  position: relative;
  ${(props) =>
    props.$isKudos &&
    `
    border: 1px solid ${props.theme.colors.functional['44812F']};
  `}
  ${(props) =>
    props.flexGrow &&
    css`
      flex-grow: 1;
    `}
`;

const ReplyContainer = styled.div`
  padding-left: 0.5rem;
  display: flex;
  align-items: center;
  min-width: 65px;
  ${(props) =>
    props.alignRight &&
    css`
      padding-left: 0rem;
      padding-right: 0.5rem;
      float: right;
    `}
`;

const CommentMoreContainer = styled.div`
  position: absolute;
  right: 12px;
  top: 6px;
  padding-left: 0.5rem;
`;

const VerticalDivider = styled.span`
  height: 14px;
  width: 0px;
  border-right: 1px solid ${(props) => props.theme.palette.borders.green};
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;
